<template>
  <div>
    <x-tabula
        ref="table"
        rowKey="orderId"
        :dataSource="dataSource"
        :searchList="searchList"
        :columns="columns"
        :tableOptList="tableOptList"
        :rowOptList="rowOptList"
        :searchParams.sync="searchParams"
        :listApi="listApi"
        :addHandleParam="addHandleParam"
        :deleteParam="deleteParam"
        :rowSelection="false"
    >
      <template slot="opt_type" slot-scope="{row}">
        <span>{{ getOrderTypeDesc(row.type) }}</span>
      </template>
      <template slot="opt_useStatus" slot-scope="{row}">
        <span>{{ getUseStatusDesc(row.useStatus) }}</span>
      </template>
      <template slot="opt_orderStatus" slot-scope="{row}">
        <span>{{ getOrderStatusTypeDesc(row.orderStatus) }}</span>
      </template>
      <template slot="opt_salesStatus" slot-scope="{row}">
        <span>{{ getSalesStatusTypeDesc(row.salesStatus) }}</span>
      </template>
      <template slot="opt_settleStatus" slot-scope="{row}">
        <span>{{ getSettleStatusTypeDesc(row.settleStatus) }}</span>
      </template>
      <template slot="opt_h" slot-scope="{row}">
        <a-tooltip :title="row.title">
          <div class="feed-over-text">{{row.title}}</div>
        </a-tooltip>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { empty } from 'ant-design-vue-admin-x';
export default {
  name: 'goodsOrder',
  data () {
    return {
      activityColor: [
        'success-bg', // 销售中
        'info-bg' // 已结束
      ],
      dataSource: [],
      searchList: [
        {props: ['title'], placeholder: '商品', inputType: 'input'},
        {props: ['type'], placeholder: '类型', options: [], inputType: 'select'},
        {props: ['orderStatus'], placeholder: '支付状态', options: [], inputType: 'select'},
        {props: ['mobile'], placeholder: '付款账号', inputType: 'input'},
        {props: ['useStatus'], placeholder: '使用状态', options: [], inputType: 'select'},
        {props: ['salesStatus'], placeholder: '售后状态', options: [], inputType: 'select'},
        {props: ['settleStatus'], placeholder: '结算状态', options: [], inputType: 'select'},
        {props: ['orderId'], placeholder: '订单号', options: [], inputType: 'input'},
        {props: ['goodsId'], placeholder: '商品编号', options: [], inputType: 'input'},
        {props: ['seckillId'], placeholder: '活动ID', options: [], inputType: 'input'}
      ],
      columns: [
        {title: '昵称', dataIndex: 'nickName', align: '', width: ''},
        {title: '账号', dataIndex: 'mobile', align: '', width: ''},
        {title: '商品', dataIndex: 'title', align: '', width: '', scopedSlots: {customRender: 'h'}},
        {title: '类型', dataIndex: 'type', align: '', width: '100px', scopedSlots: {customRender: 'type'}},
        {title: '数量', dataIndex: 'totalCount', align: '', width: '50px'},
        {title: '总价', dataIndex: 'totalFee', align: '', width: ''},
        {title: '实付', dataIndex: 'payFee', align: '', width: ''},
        {title: '付款时间', dataIndex: 'payTime', align: '', width: ''},
        {title: '使用状态', dataIndex: 'useStatus', align: '', width: '90px', scopedSlots: {customRender: 'useStatus'}},
        {
          title: '支付状态',
          dataIndex: 'orderStatus',
          align: '',
          width: '120px',
          scopedSlots: {customRender: 'orderStatus'}
        },
        {
          title: '售后状态',
          dataIndex: 'salesStatus',
          align: '',
          width: '90px',
          scopedSlots: {customRender: 'salesStatus'}
        },
        {
          title: '结算状态',
          dataIndex: 'settleStatus',
          align: '',
          width: '90px',
          scopedSlots: {customRender: 'settleStatus'}
        },
        {title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'}}
      ],
      tableOptList: [],
      rowOptList: [
        {
          text: '详情',
          handle: (row) => this.toDetail(row.orderId, row.type),
          permi: ['community:localOrder:detail']
        }
      ],
      searchParams: {
        // 团购id
        goodsId: undefined,
        // 商品名称
        title: undefined,
        // 类型
        type: undefined,
        // 订单状态
        orderStatus: undefined,
        // 使用状态
        useStatus: undefined,
        // 结算状态
        settleStatus: undefined,
        // 是否售后
        salesStatus: undefined,
        // 电话
        mobile: undefined,
        orderId: undefined,
        goodsId: undefined,
        seckillId: undefined
      },
      listApi: {
        url: '/local/order/list',
        resHandle: '', // this.resHandle
        searchHandle: this.searchHandle // searchHandle
      },
      addHandleParam: {},
      deleteParam: {}
    };
  },
  created () {
    if (this.$route.query.goodsId) {
      this.searchParams.goodsId = this.$route.query.goodsId;
      this.$nextTick(() => {
        empty.$emit('setSearchValue', {
          goodsId: this.$route.query.goodsId
        });
        this.$refs.table.$refs.search.changeFold();
      });
    }
    if (this.$route.query.seckillId) {
      this.searchParams.seckillId = this.$route.query.seckillId;
      this.$nextTick(() => {
        empty.$emit('setSearchValue', {
          seckillId: this.$route.query.seckillId
        });
        this.$refs.table.$refs.search.changeFold();
      });
    }
    this.getSelect();
  },
  methods: {
    getSelect () {
      // 获取类型下拉
      this.$get({
        url: '/dict/data/dictType/comu_local_good_type',
        params: {}
      }).then(({data}) => {
        this.searchList[1].options = data;
      });
      // 获取支付状态
      this.$get({
        url: '/dict/data/dictType/comu_local_order_status',
        params: {}
      }).then(({data}) => {
        this.searchList[2].options = data;
      });
      // 获取使用状态
      this.$get({
        url: '/dict/data/dictType/comu_local_use_status',
        params: {}
      }).then(({data}) => {
        this.searchList[4].options = data;
      });

      // 获取退款类型
      this.$get({
        url: '/dict/data/dictType/comu_local_sales_status',
        params: {}
      }).then(({data}) => {
        this.searchList[5].options = data;
      });
      // 获取结算类型
      this.$get({
        url: '/dict/data/dictType/comu_local_settle_status',
        params: {}
      }).then(({data}) => {
        this.searchList[6].options = data;
      });
    },

    getDesc (type, typeArr) {
      for (let i = 0; i < typeArr.length; i++) {
        if (typeArr[i].value === type + '') {
          return typeArr[i].label;
        }
      }
      return '';
    },

    // 活动类型1：活动 2：团购 3：商家
    getOrderTypeDesc (type) {
      return this.getDesc(type, this.searchList[1].options);
    },

    // 支付状态 0待付款 1已付款  2已超时/关闭  3已退款（全部退款才会更新为该状态）
    getOrderStatusTypeDesc (type) {
      return this.getDesc(type, this.searchList[2].options);
    },

    getUseStatusDesc (type) {
      return this.getDesc(type, this.searchList[4].options);
    },

    // 是否售后 - 0无，1存在退款
    getSalesStatusTypeDesc (type) {
      return this.getDesc(type, this.searchList[5].options);
    },
    // 0未结算，1待结算，2部分结算，3全部结算
    getSettleStatusTypeDesc (type) {
      return this.getDesc(type, this.searchList[6].options);
    },

    toDetail (id, type) {
      this.$router.push({
        name: 'localOrderDetail',
        query: {
          id: id,
          type,
          methods: {
            getOrderTypeDesc: this.getOrderTypeDesc,
            getOrderStatusTypeDesc: this.getOrderStatusTypeDesc,
            getUseStatusDesc: this.getUseStatusDesc,
            getSalesStatusTypeDesc: this.getSalesStatusTypeDesc,
            getSettleStatusTypeDesc: this.getSettleStatusTypeDesc
          },
          ...this.breadParam(this)
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
